module.exports = __webpack_public_path__ + "img/VL_07_03.5bcd2577.png";